// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../styles/variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Fixed stack in the top-right corner, offset down so it clears the sticky
   app TopBar (see components/layout/TopBar.css, z-index --z-sticky). */
.toast-container {
    position: fixed;
    top: calc(var(--space-2xl) + var(--space-md));
    right: var(--space-lg);
    z-index: var(--z-popover);
    display: flex;
    flex-direction: column;
    gap: var(--space-sm);
    width: min(360px, calc(100vw - 2 * var(--space-lg)));
    pointer-events: none;
}

.toast {
    display: flex;
    align-items: flex-start;
    gap: var(--space-sm);
    padding: var(--space-md);
    border-radius: var(--radius-lg);
    border: 1px solid var(--glass-border);
    border-left: 3px solid var(--color-info);
    background: var(--glass-bg-strong);
    backdrop-filter: blur(14px);
    -webkit-backdrop-filter: blur(14px);
    box-shadow: var(--shadow-lg);
    color: var(--text-primary);
    font-size: var(--font-size-sm);
    line-height: var(--line-height-normal);
    pointer-events: auto;
    animation: toast-in var(--transition-slow);
}

.toast-icon {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 1.25rem;
    height: 1.25rem;
    border-radius: var(--radius-full);
    font-size: var(--font-size-xs);
    font-weight: var(--font-weight-bold);
    color: var(--color-white);
}

.toast-message {
    flex: 1 1;
    min-width: 0;
    word-break: break-word;
}

.toast-dismiss {
    flex-shrink: 0;
    padding: 0;
    width: 1.25rem;
    height: 1.25rem;
    line-height: 1;
    border: none;
    background: transparent;
    color: var(--text-faint);
    font-size: var(--font-size-lg);
    cursor: pointer;
    transition: color var(--transition-fast);
}

.toast-dismiss:hover {
    color: var(--text-primary);
}

/* Type accents — left border + icon chip colour. */
.toast-success {
    border-left-color: var(--color-success);
}

.toast-success .toast-icon {
    background: var(--color-success);
}

.toast-error {
    border-left-color: var(--color-error);
}

.toast-error .toast-icon {
    background: var(--color-error);
}

.toast-warning {
    border-left-color: var(--color-warning);
}

.toast-warning .toast-icon {
    background: var(--color-warning);
    color: var(--color-dark);
}

.toast-info {
    border-left-color: var(--color-info);
}

.toast-info .toast-icon {
    background: var(--color-info);
}

@keyframes toast-in {
    from {
        opacity: 0;
        transform: translateX(1rem);
    }

    to {
        opacity: 1;
        transform: translateX(0);
    }
}

@media (max-width: 480px) {
    .toast-container {
        top: calc(var(--space-xl) + var(--space-md));
        right: var(--space-sm);
        left: var(--space-sm);
        width: auto;
    }
}
`, "",{"version":3,"sources":["webpack://./src/context/ToastContext.css"],"names":[],"mappings":"AAEA;uEACuE;AACvE;IACI,eAAe;IACf,6CAA6C;IAC7C,sBAAsB;IACtB,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,oDAAoD;IACpD,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,oBAAoB;IACpB,wBAAwB;IACxB,+BAA+B;IAC/B,qCAAqC;IACrC,wCAAwC;IACxC,kCAAkC;IAClC,2BAA2B;IAC3B,mCAAmC;IACnC,4BAA4B;IAC5B,0BAA0B;IAC1B,8BAA8B;IAC9B,sCAAsC;IACtC,oBAAoB;IACpB,0CAA0C;AAC9C;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,iCAAiC;IACjC,8BAA8B;IAC9B,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,UAAU;IACV,cAAc;IACd,eAAe;IACf,cAAc;IACd,YAAY;IACZ,uBAAuB;IACvB,wBAAwB;IACxB,8BAA8B;IAC9B,eAAe;IACf,wCAAwC;AAC5C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,mDAAmD;AACnD;IACI,uCAAuC;AAC3C;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,gCAAgC;IAChC,wBAAwB;AAC5B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,4CAA4C;QAC5C,sBAAsB;QACtB,qBAAqB;QACrB,WAAW;IACf;AACJ","sourcesContent":["@import '../styles/variables.css';\n\n/* Fixed stack in the top-right corner, offset down so it clears the sticky\n   app TopBar (see components/layout/TopBar.css, z-index --z-sticky). */\n.toast-container {\n    position: fixed;\n    top: calc(var(--space-2xl) + var(--space-md));\n    right: var(--space-lg);\n    z-index: var(--z-popover);\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-sm);\n    width: min(360px, calc(100vw - 2 * var(--space-lg)));\n    pointer-events: none;\n}\n\n.toast {\n    display: flex;\n    align-items: flex-start;\n    gap: var(--space-sm);\n    padding: var(--space-md);\n    border-radius: var(--radius-lg);\n    border: 1px solid var(--glass-border);\n    border-left: 3px solid var(--color-info);\n    background: var(--glass-bg-strong);\n    backdrop-filter: blur(14px);\n    -webkit-backdrop-filter: blur(14px);\n    box-shadow: var(--shadow-lg);\n    color: var(--text-primary);\n    font-size: var(--font-size-sm);\n    line-height: var(--line-height-normal);\n    pointer-events: auto;\n    animation: toast-in var(--transition-slow);\n}\n\n.toast-icon {\n    flex-shrink: 0;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 1.25rem;\n    height: 1.25rem;\n    border-radius: var(--radius-full);\n    font-size: var(--font-size-xs);\n    font-weight: var(--font-weight-bold);\n    color: var(--color-white);\n}\n\n.toast-message {\n    flex: 1;\n    min-width: 0;\n    word-break: break-word;\n}\n\n.toast-dismiss {\n    flex-shrink: 0;\n    padding: 0;\n    width: 1.25rem;\n    height: 1.25rem;\n    line-height: 1;\n    border: none;\n    background: transparent;\n    color: var(--text-faint);\n    font-size: var(--font-size-lg);\n    cursor: pointer;\n    transition: color var(--transition-fast);\n}\n\n.toast-dismiss:hover {\n    color: var(--text-primary);\n}\n\n/* Type accents — left border + icon chip colour. */\n.toast-success {\n    border-left-color: var(--color-success);\n}\n\n.toast-success .toast-icon {\n    background: var(--color-success);\n}\n\n.toast-error {\n    border-left-color: var(--color-error);\n}\n\n.toast-error .toast-icon {\n    background: var(--color-error);\n}\n\n.toast-warning {\n    border-left-color: var(--color-warning);\n}\n\n.toast-warning .toast-icon {\n    background: var(--color-warning);\n    color: var(--color-dark);\n}\n\n.toast-info {\n    border-left-color: var(--color-info);\n}\n\n.toast-info .toast-icon {\n    background: var(--color-info);\n}\n\n@keyframes toast-in {\n    from {\n        opacity: 0;\n        transform: translateX(1rem);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateX(0);\n    }\n}\n\n@media (max-width: 480px) {\n    .toast-container {\n        top: calc(var(--space-xl) + var(--space-md));\n        right: var(--space-sm);\n        left: var(--space-sm);\n        width: auto;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
